<template>
  <fragment>
    <div
      v-for="(category, categoryID) in categories"
      :key="categoryID"
      :class="`p-1 border whitespace-no-wrap overflow-hidden ${checkTemp(categoryID)}`"
      style="width: 20%"
    >
      <div
        v-if="categoryID === 'type'"
        class="flex justify-center"
      >
        <eva-icon
          class="mr-2"
          :name="getIconType[source[categoryID]]"
          fill="#6C63FF"
        />
        <div>{{ getStringType[source[categoryID]] }}</div>
      </div>
      <div v-else>
        {{ source[categoryID] }}
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'RegistrationTableRow',
  props: {
    temperatureLimit: {
      type: Number,
      default: 0,
    },
    categories: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    source: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
    }
  },
  computed: {
    getIconType () {
      return {
        user: 'file-text-outline',
        camera: 'video-outline',
        guest: 'people-outline',
        RS: 'car-outline',
      }
    },
    getStringType () {
      return {
        user: 'Manual',
        camera: 'Camara',
        guest: 'Invitado',
        RS: 'RS',
      }
    },
    ...mapState({
      persons: state => state.admin.persons,
    }),
  },
  mounted () {
  },
  methods: {
    checkTemp (categoryID) {
      if (categoryID === 'temperature' && this.temperatureLimit > 0) return this.source[categoryID] > this.temperatureLimit ? 'text-red-500 font-bold' : ''
      return ''
    },
    dispatch (componentName, eventName, ...rest) {
      let parent = this.$parent || this.$root
      let name = parent.$options.name

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent
        if (parent) {
          name = parent.$options.name
        }
      }

      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(rest))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../css/_brand";
</style>
